export const FILTER_TYPE_CATEGORY: string = 'category';
export const FILTER_TYPE_DEAL_ID: string = 'dealId';
export const FILTER_TYPE_BROKER_ID: string = 'brokerId';
export const FILTER_TYPE_LENDER_ID: string = 'lenderId';
export const FILTER_TYPE_INVESTOR_ID: string = 'investorId';
export const FILTER_TYPE_DEAL_CONTACT_ID: string = 'dealContactId';
export const FILTER_TYPE_TYPE: string = 'type';
export const FILTER_TYPE_CONTACT_TYPE: string = 'contactType';
export const FILTER_TYPE_COMPANY_ID: string = 'companyId';
export const FILTER_TYPE_LOCATION: string = 'location';
export const FILTER_TYPE_ASSET_TYPE: string = 'assetType';
export const FILTER_TYPE_TAG_ID: string = 'tagId';
export const FILTER_TYPE_DEAL_TYPE: string = 'dealType';
export const FILTER_TYPE_DEAL_SIZE: string = 'dealSize';
export const FILTER_TYPE_USER_ID: string = 'userId';
export const FILTER_TYPE_DEAL_OPERATION_TYPE: string = 'type';
export const FILTER_TYPE_USER_EMAIL: string = 'email';
export const FILTER_TYPE_EMAIL_MESSAGE_TYPE: string = 'type';
export const FILTER_TYPE_OPERATION_TYPE: string = 'operationType';
export const FILTER_TYPE_ENTITY_TYPE: string = 'entityType';
export const FILTER_TYPE_ACCOUNT_USER_TYPE: string = 'accountUserType';
export const FILTER_TYPE_ROLE: string = 'role';
export const FILTER_TYPE_ACTIVE: string = 'active';
export const FILTER_TYPE_ACCESS_LEVEL: string = 'accessLevel';
export const FILTER_TYPE_CONTACT_ID: string = 'contactId';
export const FILTER_TYPE_STATUS: string = 'status';
export const FILTER_TYPE_API_ENDPOINT: string = 'endpoint';
export const FILTER_TYPE_REPORT_ID: string = 'reportId';
export const FILTER_TYPE_CREATE_DATE_FROM: string = 'createDateFrom';
export const FILTER_TYPE_CREATE_DATE_TO: string = 'createDateTo';
